<as-split unit="pixel" direction="horizontal">
  @if (showFiltersPanel()) {
    <div class="order-item">
      <div (click)="toggleShowingFiltersPanel()" class="filter-toggle-text" style="cursor: pointer; top: 0.7rem; margin-bottom: 1rem;">
        @if (showFiltersPanel()) {
          <mat-icon>navigate_before</mat-icon>
        }
        @if (!showFiltersPanel()) {
          <mat-icon>navigate_next</mat-icon>
        }
        <span>Filters</span>
      </div>
      
      <app-order-refresh-timer [isLoadingData]="isRetrievingAllOrderData()"></app-order-refresh-timer>

      <insight-filters [filtersSubject]="filtersSubject" [shouldSetUrlPrams]="true"></insight-filters>
      <form [formGroup]="viewTypeForm" class="sidebar-form">
        <mat-form-field>
          <mat-label>Order View</mat-label>
          <mat-select formControlName="orderView">
            <mat-option value="status">Status</mat-option>
            <mat-option value="ship-date">Ship Date</mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field>
          <mat-label>Market</mat-label>
          <mat-select formControlName="marketFilter" multiple>
            <mat-select-trigger>
              @if (viewTypeForm.controls.marketFilter.value?.length > 1) {
                <span>
                  {{ viewTypeForm.controls.marketFilter.value.length }} selected
                </span>
              } @else {
                {{ orderUtilityService.getMarketName(viewTypeForm.controls.marketFilter.value[0].orgType, false) }}
              }
            </mat-select-trigger>
            <mat-option [value]="defaultAllMarketOption">All</mat-option>
            @for (market of availableMarkets; track market.orgType + '|' + market.salesDivision) {
              <mat-option [value]="market">{{ orderUtilityService.getMarketName(market.orgType) }}</mat-option>
            }
          </mat-select>
        </mat-form-field>
        <mat-form-field>
          <mat-label>Sales Rep</mat-label>
          <mat-select formControlName="salesRepFilter">
            <mat-option value="all">All</mat-option>
            @for (reps of availableSalesReps; track reps.salesRepName) {
              <mat-option value="{{reps.salesRepName}}">{{ reps.salesRepName}}</mat-option>
            }
          </mat-select>
        </mat-form-field>
      </form>
    </div>
  }

  <!-- UI in the case the filters are collapse to bring it back-->
  @if (!showFiltersPanel()) {
    <div (click)="toggleShowingFiltersPanel()"
          class="order-item filter-toggle-text collapsed">
      <span class="collapsed-filters-panel">
        @if (showFiltersPanel()) {
          <mat-icon>navigate_before</mat-icon>
        }
        @if (!showFiltersPanel()) {
          <mat-icon>navigate_next</mat-icon>
        }
        <span style="writing-mode: vertical-lr; text-orientation: mixed;">Filters</span>
      </span>
    </div>
  }

  <!-- orders listing-->
  <as-split-area [size]="600" [minSize]="360">
    <!-- static search area-->
    <!-- search textfield-->
    <form [formGroup]="orderSearchForm" class="order-search-form flex-layout no-wrap">
      <div class="flex-layout center-content no-wrap no-gap">
        <!-- order search type-->
        <mat-form-field>
          <mat-label>Search type</mat-label>
          <mat-select formControlName="orderSearchTypeControl">
            <mat-option value="order-number">Order Number</mat-option>
            <mat-option value="customer-number">Customer Number</mat-option>
            <mat-option value="portal-guid">Portal ID</mat-option>
          </mat-select>
        </mat-form-field>

        @if (shouldShowCustomerNumberNotice()) {
          <mat-icon style="opacity: 0.5;" title="Search by Customer Number only includes orders from the past 2 years that aren't holdovers or re-burns.">info</mat-icon>
        }
      </div>
      <mat-form-field id="search-text-field">
        <input formControlName="searchFormController" matInput placeholder="Search ">
      </mat-form-field>

      <mat-icon aria-hidden="false" aria-label="Search Icon" style="top: 0rem; position: relative; right: 0.25rem;">search</mat-icon>

      @if (isRetrievingSearchData()) {
        <mat-spinner style="display: inline-block" [diameter]="25" [strokeWidth]="4"></mat-spinner>
      }
    </form>

    <!-- order listing results-->
    <div style="height: calc(100vh - 5.25rem - 60px); overflow-y: auto;">
      <!-- show open orders. component will render nothing if no open orders -->
      <app-open-orders-view [openOrders]="openOrders()"></app-open-orders-view>

      <!-- listing of all the orders. Two different views currently -->
      @if (currentOrderView() === 'status') {
        <app-order-view-status [orderShipmentGroups]="filteredOrderShipmentGroups()" 
          (selectedOrderEvent)="selectOrder($event)"></app-order-view-status>
      }
      @if (currentOrderView() === 'ship-date') {
        @for (orderShipment of filteredOrders(); track orderShipment.sourceSystem + ':' + orderShipment.orderNumber + ':' + orderShipment.shipmentNumber) {
          <insight-order [isSelected]="isOrderCurrentlySelected(orderShipment)" 
            (selectedOrderEvent)="selectOrder($event)" 
            [orderScreen]="orderScreens.Dashboard" [orderShipment]="orderShipment"></insight-order>
        }
      }
      
      <!-- no results found if no data-->      
      @if (isInitialLoadComplete() && filteredOrders().length === 0 && filteredOrderShipmentGroups().length === 0 && !isRetrievingAllOrderData()) {
        <div class="mt-6 text-center">
          <em>No orders found</em>
        </div>
      }

      <!-- content placeholder to indicate data is loading. Only show with initial loading when page is empty  -->
      @if (!isInitialLoadComplete()) {
        <div class="loading-orders-animation">
          @if (this.allOrderShipmentGroupsList?.lastCacheProcessingError !== null) {            
            <div class="cache-error">
              <div class="cache-error-title">                
                <mat-icon>warning</mat-icon>
                <span>Error loading all orders</span>
              </div>
              <span>{{this.allOrderShipmentGroupsList?.lastCacheProcessingError}}</span>              
            </div>
          } @else {
            <content-loader [foregroundColor]="'#ddd'" [backgroundColor]="'#eee'" [viewBox]="'0 0 180 400'">
              <svg:rect x="0" y="0" rx="3" ry="3" width="100%" height="25" />
              <svg:rect x="0" y="30" rx="3" ry="3" width="100%" height="25" />
              <svg:rect x="0" y="60" rx="3" ry="3" width="100%" height="25" />
              <svg:rect x="0" y="90" rx="3" ry="3" width="100%" height="25" />
              <svg:rect x="0" y="120" rx="3" ry="3" width="100%" height="25" />
              <svg:rect x="0" y="150" rx="3" ry="3" width="100%" height="25" />
            </content-loader>
          }
        </div>
      }
    </div>
  </as-split-area>

  <!-- order details  area-->
  <as-split-area [size]="null">
    <!-- currently selected order shipment details -->
    <div style="overflow-y: auto; min-width: 25rem; height: calc(100vh - 60px);">
      @if(orderDetailsConfig(); as orderConfig) {
        <!-- only load shipment details component if we have all the data needed to make query
        things like source system can be 0. We just want to make sure there is something there -->
        @if(orderConfig.orderNumber >= 0 && orderConfig.shipmentNumber >= 0 && orderConfig.sourceSystem >= 0) {
          <insight-order-shipment-details [orderShipmentConfig]="orderConfig"></insight-order-shipment-details>
        } @else {
          <span class="awaiting-order-details-message">
            @if(isRetrievingAllOrderData() && isInitialLoadComplete() === false) {
              <mat-spinner [diameter]="30" [strokeWidth]="4"></mat-spinner>
              <span>Waiting for orders to load</span>
            } @else {
              <!-- This usually happens if time frame is short and no orders are returned -->
              <span>No order to display</span>
            }
          </span>
        }
      }
    </div>
  </as-split-area>
</as-split>
